import { lighten, rgba } from "polished";
import { NavLink as RouterLink } from "react-router-dom";
import styled from "styled-components";
import { Box, Flex } from "../../ppui/layout";
import { theme } from "../../theme";
export const NavWrapper = styled(Box)(() => ({
  position: "fixed",
  zIndex: 11,
  height: "100%",
  width: "18.75rem",
  overflow: "auto",
  backgroundColor: ` ${theme.colors.light.light} `,
  left: 0,
  top: 0,
  transition: "all .3s",
  fontFamily: theme.typography.fontFamily,
  "&.navCollapse": {
    width: "5rem",
    overflow: "visible",
  },
}));
export const BrandWrapper = styled(Flex)(() => ({
  position: "sticky",
  left: 0,
  top: 0,
  alignItems: "center",
  height: "4.375rem",
  padding: "0.5rem",
  zIndex: 10,
  backgroundColor: theme.colors.light.light,
  boxShadow: `0px 0.125rem 0.9375rem ${rgba(theme.colors.dark.dark, 0.05)} `,
  borderEndEndRadius: "0.9375rem",
}));
export const Brand = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "3.125rem",
  padding: "0.5rem",
  borderRadius: "0.625rem",
  backgroundColor: rgba(`${theme.colors.secondary.light}`, 0.15),
}));

export const NavPart = styled("nav")(() => ({
  padding: "0.9375rem 0.625rem",
}));
export const NavStyle = styled("ul")(() => ({
  display: "flex",
  flexDirection: "column",
  listStyle: "none",
  padding: 0,
  margin: 0,
  gap: "0.25rem",
  "&>li": {
    position: "relative",
    transition: "all .3s",
    borderRadius: theme.radius.list,
    "&.active": {
      // backgroundColor:theme.colors.background.main,
      backgroundColor: lighten(0.35, theme.colors.secondary.main),
    },
  },
}));

export const NavTitle = styled(({ component, className, ...props }) => {
  const Element = component || RouterLink;
  return <Element className={className} {...props} />;
})(() => {
  return {
    cursor: "pointer",
    color: theme.colors.primary.light,
    fontSize: "1rem",
    fontWeight: 500,
    padding: "0.5rem 0.75rem 0.5rem 1.25rem",
    gap: "0.875rem",
    display: "flex",
    alignItems: "center",
    position: "relative",
    whiteSpace: "nowrap",
    flexWrap: "nowrap",
    overflow: "hidden",
    borderRadius: theme.radius.list,
    "&:hover": {
      backgroundColor: rgba(theme.colors.background.main, 1),
    },
    "&.active": {
      // backgroundColor:rgba(theme.colors.secondary.light,0.15),
      backgroundColor: rgba(theme.colors.background.main, 1),
      color: theme.colors.primary.dark,
      fontWeight: 600,
    },
  };
});
export const NavIcon = styled(Flex)(() => ({
  width: "1.5rem",
  minWidth: "1.5rem",
  height: "1.75rem",
  alignItems: "center",
  justifyContent: "center",
}));
export const ExpandIcon = styled(Flex)(() => ({
  width: "0.9375rem",
  minWidth: "0.9375rem",
  height: "0.9375rem",
  alignItems: "center",
  justifyContent: "center",
  marginInlineStart: "auto",
}));

export const NavSubStyle = styled("div")(({ sx = {} }) => ({
  padding: 0,
  position: "relative",
  zIndex: 2,
  overflow: "hidden",
  transition: "max-height 0.3s",
  ...sx,
  "&.collapseNav": {
    position: "absolute",
    left: "calc(100% + 0.625rem)",
    top: 0,
    borderEndEndRadius: theme.radius.list,
    borderStartEndRadius: theme.radius.list,
    backgroundColor: theme.colors.light.light,
    boxShadow: `0px 0.125rem 0.9375rem ${rgba(theme.colors.dark.dark, 0.05)} `,
  },
  "& ul": {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: "0.625rem",
    listStyle: "none",
    gap: "0.125rem",
    transition: "max-height 0.3s",
  },
  "& li": {
    paddingInlineStart: "2.5rem",
    position: "relative",
    // "&:last-child":{marginBlockEnd:"0.625rem"},
    "&:before": {
      content: `''`,
      position: "absolute",
      left: "1.25rem",
      bottom: "50%",
      height: "3.75rem",
      width: "1.25rem",
      borderEndStartRadius: "0.938rem",
      border: `${rgba(theme.colors.dark.dark, 0.2)} solid 0.0625rem`,
      borderBlockStart: "0",
      borderInlineEnd: "0",
    },
    "&.disable":{
      opacity:0.6,
      pointerEvents: "none",
    }
  },
}));
export const NavSubTitle = styled("div")(() => ({
  cursor: "pointer",
  fontSize: "1rem",
  fontWeight: 500,
  padding: "0.9375rem 0.75rem 0.5rem 1.25rem",
  gap: "0.875rem",
  display: "flex",
  alignItems: "center",
  position: "relative",
  zIndex: 2,
  whiteSpace: "nowrap",
  flexWrap: "nowrap",
  overflow: "hidden",
  borderRadius: theme.radius.list,
  backgroundColor: theme.colors.light.light,
}));
export const NavSubLink = styled(RouterLink)(() => ({
  cursor: "pointer",
  color: theme.colors.primary.light,
  fontSize: "0.875rem",
  fontWeight: 400,
  padding: "0.375rem 0.625rem",
  gap: "0.875rem",
  display: "flex",
  alignItems: "center",
  position: "relative",
  whiteSpace: "nowrap",
  flexWrap: "nowrap",
  overflow: "hidden",
  borderRadius: theme.radius.element,
  transition: "all .3s",
  "&:hover": {
    // backgroundColor:rgba(theme.colors.default.main,0.5),
    backgroundColor: theme.colors.light.light,
  },
  "&.active": {
    backgroundColor: theme.colors.light.light,
    color: theme.colors.primary.dark,
    fontWeight: 500,
    paddingInlineStart: "1.25rem",
  },
}));

